import { playDtmfTone } from "@/lib/callTones";
import { faDeleteLeft, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC, useState } from "react";
import { Button, Form } from "react-bootstrap";

export interface DialKey {
  digit: string;
  letters?: string;
}

export const KEYS: DialKey[] = [
  { digit: "1" },
  { digit: "2", letters: "ABC" },
  { digit: "3", letters: "DEF" },
  { digit: "4", letters: "GHI" },
  { digit: "5", letters: "JKL" },
  { digit: "6", letters: "MNO" },
  { digit: "7", letters: "PQRS" },
  { digit: "8", letters: "TUV" },
  { digit: "9", letters: "WXYZ" },
  { digit: "*" },
  { digit: "0" },
  { digit: "#" },
];

interface IProps {
  onCall: (number: string) => void;
}

const WebphoneKeypad: FC<IProps> = ({ onCall }) => {
  const [number, setNumber] = useState("");

  const onKeyPress = (key: string) => {
    playDtmfTone(key);
    setNumber((old) => old + key);
  };
  const onBackspace = () => setNumber((old) => old.slice(0, -1));

  const onSubmit = () => {
    if (!number) return;
    onCall(number);
    setNumber("");
  };

  return (
    <div className="px-3 pb-3">
      <div className="d-flex align-items-center mb-3">
        <Form.Control
          type="tel"
          placeholder="Numéro"
          value={number}
          onChange={(e) => setNumber(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && onSubmit()}
          className="webphone-number-input text-center border-0 rounded-pill"
        />
        {number && (
          <Button
            variant="link"
            className="text-body-tertiary ms-1 p-2"
            aria-label="Effacer le dernier chiffre"
            onClick={onBackspace}
          >
            <FontAwesomeIcon icon={faDeleteLeft} />
          </Button>
        )}
      </div>

      <div className="webphone-keypad-grid mb-3">
        {KEYS.map(({ digit, letters }) => (
          <button
            key={digit}
            type="button"
            className="webphone-key"
            onClick={() => onKeyPress(digit)}
            aria-label={letters ? `${digit}, ${letters.split("").join(" ")}` : digit}
          >
            <span className="webphone-key-digit">
              {digit}
              {digit === "0" && <sup>+</sup>}
            </span>
            {letters && <span className="webphone-key-letters">{letters}</span>}
          </button>
        ))}
      </div>

      <div className="d-flex justify-content-center">
        <button
          type="button"
          className="webphone-call-btn"
          aria-label="Appeler"
          disabled={!number}
          onClick={onSubmit}
        >
          <FontAwesomeIcon icon={faPhone} />
        </button>
      </div>
    </div>
  );
};

export default WebphoneKeypad;
